import { render, staticRenderFns } from "./Fetch.vue?vue&type=template&id=3370d0a2&scoped=true&"
import script from "./Fetch.vue?vue&type=script&lang=js&"
export * from "./Fetch.vue?vue&type=script&lang=js&"
import style0 from "./Fetch.vue?vue&type=style&index=0&id=3370d0a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370d0a2",
  null
  
)

component.options.__file = "Fetch.vue"
export default component.exports